export interface ClassScheduleType extends ScheduleClass {
  class: string
  type: 'class'
}
export interface CustomClassScheduleType extends ScheduleClass {
  name: string
  type: 'custom'
}
export interface CustomSpecialScheduleType extends ScheduleClass {
  class: string
  type: 'customSpecial'
}
export interface PrepClassScheduleType extends ScheduleClass {
  type: 'prep'
}
export interface ScheduleClass {
  type: string
  periodID: string
}
export type GenericUserSchedule = {
  community: string
  user: string
  classes: ScheduleClass[]
  options?: UserScheduleOptions
}
export type UserScheduleOptions = {
  showPreps?: boolean
}
// {  "_id": {    "$oid": "618456eb6d199d8de5e1e482"  },  "community": "tet",  "periods": {    "p0": "Period 0",    "p1": "Period 1",    "p2": "Period 2",    "p3": "Period 3",    "p4": "Period 4",    "p5": "Period 5",    "p6": "Period 6",    "p7": "Period 7",    "p8": "Period 8",    "p9": "Brunch",    "p10": "Lunch",    "p11": "PRIME",    "p12": "SELF"  },  "scheduleType": "weekly",  "scheduleDays": {    "monday": [      {        "period": "p0",        "starts": "7:55AM",        "ends": "8:50AM"      },      {        "period": "p1",        "starts": "9:00AM",        "ends": "9:45AM"      },      {        "period": "p2",        "starts": "9:55AM",        "ends": "10:40AM"      },      {        "period": "p9",        "starts": "10:40AM",        "ends": "10:45AM"      },      {        "period": "p3",        "starts": "10:55AM",        "ends": "11:40AM"      },      {        "period": "p4",        "starts": "11:50AM",        "ends": "12:35PM"      },      {        "period": "p10",        "starts": "12:35PM",        "ends": "1:05PM"      },      {        "period": "p5",        "starts": "1:15PM",        "ends": "2:00PM"      },      {        "period": "p6",        "starts": "2:10PM",        "ends": "2:55PM"      },      {        "period": "p7",        "starts": "3:05PM",        "ends": "3:50PM"      },      {        "period": "p8",        "starts": "4:00PM",        "ends": "4:45PM"      }    ],    "tuesday": [      {        "period": "p0",        "starts": "7:55AM",        "ends": "8:50AM"      },      {        "period": "p1",        "starts": "9:00AM",        "ends": "10:35AM"      },      {        "period": "p9",        "starts": "10:35AM",        "ends": "10:40AM"      },      {        "period": "p2",        "starts": "10:50AM",        "ends": "12:20PM"      },      {        "period": "p10",        "starts": "12:20PM",        "ends": "12:50PM"      },      {        "period": "p3",        "starts": "1:00PM",        "ends": "2:30PM"      },      {        "period": "p4",        "starts": "2:40PM",        "ends": "4:10PM"      },      {        "period": "p8",        "starts": "4:20PM",        "ends": "5:55PM"      }    ],    "wednesday": [      {        "period": "p0",        "starts": "7:55AM",        "ends": "8:50AM"      },      {        "period": "p5",        "starts": "9:00AM",        "ends": "10:35AM"      },      {        "period": "p9",        "starts": "10:35AM",        "ends": "10:40AM"      },      {        "period": "p6",        "starts": "10:50AM",        "ends": "12:20PM"      },      {        "period": "p10",        "starts": "12:20PM",        "ends": "12:50PM"      },      {        "period": "p7",        "starts": "1:00PM",        "ends": "2:30PM"      },      {        "period": "p11",        "starts": "2:40PM",        "ends": "3:30PM"      }    ],    "thursday": [      {        "period": "p0",        "starts": "7:55AM",        "ends": "8:50AM"      },      {        "period": "p1",        "starts": "9:00AM",        "ends": "10:35AM"      },      {        "period": "p9",        "starts": "10:35AM",        "ends": "10:40AM"      },      {        "period": "p2",        "starts": "10:50AM",        "ends": "12:20PM"      },      {        "period": "p10",        "starts": "12:20PM",        "ends": "12:50PM"      },      {        "period": "p3",        "starts": "1:00PM",        "ends": "2:30PM"      },      {        "period": "p4",        "starts": "2:40PM",        "ends": "4:10PM"      },      {        "period": "p8",        "starts": "4:20PM",        "ends": "5:55PM"      }    ],    "friday": [      {        "period": "p5",        "starts": "9:00AM",        "ends": "10:35AM"      },      {        "period": "p9",        "starts": "10:35AM",        "ends": "10:40AM"      },      {        "period": "p6",        "starts": "10:50AM",        "ends": "12:20PM"      },      {        "period": "p10",        "starts": "12:20PM",        "ends": "12:50PM"      },      {        "period": "p7",        "starts": "1:00PM",        "ends": "2:30PM"      },      {        "period": "p12",        "starts": "2:40PM",        "ends": "3:30PM"      }    ]  },  "timezone": "America/Los_Angeles"}
export type GenericMasterSchedule = {
  community: string
  timezone: string
  periods: {
    [periodID: string]: string
  }
  schedule: ABABSchedule | WeeklySchedule | DailySchedule
  icals: ICalSchedule[] //Max 5
}
export enum ScheduleType {
  abab = 'abab',
  weekly = 'weekly',
  daily = 'daily',
}
//86400000 ms in a day
export type ScheduleClassEvent = {
  period: string
  from: number // ms since 12am
  to: number // ms since 12am
}
export type ABABSchedule = {
  firstChunk: 'a' | 'b'
  a: ScheduleClassEvent[]
  b: ScheduleClassEvent[]
  scheduleType: ScheduleType.abab
}
export type WeeklySchedule = {
  monday: ScheduleClassEvent[]
  tuesday: ScheduleClassEvent[]
  wednesday: ScheduleClassEvent[]
  thursday: ScheduleClassEvent[]
  friday: ScheduleClassEvent[]
  saturday: ScheduleClassEvent[]
  sunday: ScheduleClassEvent[]
  scheduleType: ScheduleType.weekly
}
export type DailySchedule = {
  scheduleType: ScheduleType.daily
  classes: ScheduleClassEvent[]
}

export type ICalSchedule = {
  icalLink: string
  scheduleOverride: boolean // if true, this schedule overrides the community schedule for the specified day
}
